"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _HorizontalRule = _interopRequireDefault(require("../HorizontalRule"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      breakpoint = _useTheme.breakpoint;

  return {
    root: (0, _defineProperty2.default)({}, breakpoint.up('lg'), {
      display: 'none'
    })
  };
};

__signature__(useStyles, "useTheme{{ breakpoint }}", function () {
  return [_useTheme2.default];
});

var Divider = function Divider() {
  var classes = useStyles();
  return (0, _core.jsx)(_HorizontalRule.default, {
    css: classes.root
  });
};

__signature__(Divider, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = Divider;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Divider.tsx");
  reactHotLoader.register(Divider, "Divider", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Divider.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Divider.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9SZXNwb25zaXZlSGVhZGVyL0RpdmlkZXIudHN4Il0sIm5hbWVzIjpbInVzZVN0eWxlcyIsImJyZWFrcG9pbnQiLCJyb290IiwidXAiLCJkaXNwbGF5IiwidXNlVGhlbWUiLCJEaXZpZGVyIiwiY2xhc3NlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQTs7QUFFQTs7QUFDQTs7Ozs7Ozs7Ozs7OztBQUVBLElBQU1BLFNBQVMsR0FBRyxTQUFaQSxTQUFZLEdBQU07QUFBQSxrQkFDQyx5QkFERDtBQUFBLE1BQ2RDLFVBRGMsYUFDZEEsVUFEYzs7QUFFdEIsU0FBTztBQUNMQyxJQUFBQSxJQUFJLG9DQUNERCxVQUFVLENBQUNFLEVBQVgsQ0FBYyxJQUFkLENBREMsRUFDcUI7QUFDckJDLE1BQUFBLE9BQU8sRUFBRTtBQURZLEtBRHJCO0FBREMsR0FBUDtBQU9ELENBVEQ7O2NBQU1KLFM7VUFDbUJLLGtCOzs7QUFVekIsSUFBTUMsT0FBMEIsR0FBRyxTQUE3QkEsT0FBNkIsR0FBTTtBQUN2QyxNQUFNQyxPQUFPLEdBQUdQLFNBQVMsRUFBekI7QUFFQSxTQUFPLGVBQUMsdUJBQUQ7QUFBZ0IsSUFBQSxHQUFHLEVBQUVPLE9BQU8sQ0FBQ0w7QUFBN0IsSUFBUDtBQUNELENBSkQ7O2NBQU1JLE87VUFDWU4sUzs7O2VBS0hNLE87Ozs7Ozs7Ozs7OzswQkFqQlROLFM7MEJBV0FNLE8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBIb3Jpem9udGFsUnVsZSBmcm9tICcuLi9Ib3Jpem9udGFsUnVsZSc7XG5pbXBvcnQgdXNlVGhlbWUgZnJvbSAnLi4vc3R5bGVzL3VzZVRoZW1lJztcblxuY29uc3QgdXNlU3R5bGVzID0gKCkgPT4ge1xuICBjb25zdCB7IGJyZWFrcG9pbnQgfSA9IHVzZVRoZW1lKCk7XG4gIHJldHVybiB7XG4gICAgcm9vdDoge1xuICAgICAgW2JyZWFrcG9pbnQudXAoJ2xnJyldOiB7XG4gICAgICAgIGRpc3BsYXk6ICdub25lJyxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSBhcyBjb25zdDtcbn07XG5cbmNvbnN0IERpdmlkZXI6IEZ1bmN0aW9uQ29tcG9uZW50ID0gKCkgPT4ge1xuICBjb25zdCBjbGFzc2VzID0gdXNlU3R5bGVzKCk7XG5cbiAgcmV0dXJuIDxIb3Jpem9udGFsUnVsZSBjc3M9e2NsYXNzZXMucm9vdH0gLz47XG59O1xuXG5leHBvcnQgZGVmYXVsdCBEaXZpZGVyO1xuIl19